<style lang="less">
.daGiftCard {
  width: 7rem;
  margin: 0 auto;
  position: relative;
  top: 0;
  left: 0;
  min-height: 2rem;
  &__img {
    position: absolute;
    top: .2rem;
    left: .2rem;
    width: 1.6rem;
    height: 1.6rem;
    img {
      width: 100%;
    }
  }
  &__info {
    padding: .2rem 0 0 2rem;
    text-align: left;
    font-size: .24rem;
    dl {
      margin: 0;
      padding: 0 0 .15rem;
    }
    dd,dt {
      margin: 0;
      padding: 0;
    }
    dt {
      font-size: .3rem;
    }
    dd {
      color: #666;
    }
  }
}
</style>
<template>
  <div class="daGiftCard">
    <div class="daGiftCard__img">
      <k-cdn-img
        src="https://imgcdn-prd.pydp888.com/file/0/1/266583/20201103/d7fa9bd5e7788ff4db5582553bd97d1e.png"
      />
    </div>
    <div class="daGiftCard__info">
      <dl>
        <dt>520版+高级股票池</dt>
        <dd>15天使用权限 1份</dd>
      </dl>
      <dl>
        <dt>每人最多10份，新用户最多11份</dt>
        <dd>每邀请3位好友助力各得1份奖励</dd>
      </dl>
    </div>
  </div>
</template>
<script>
export default {}
</script>
